var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.license)?_c('LiveChatWidget',{ref:"livechat",staticClass:"contact",attrs:{"license":_vm.license,"visibility":_vm.size},on:{"ready":_vm.ready,"visibility-changed":_vm.listen}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }